import { render } from "./system-login.vue?vue&type=template&id=d0fb20ce"
import script from "./system-login.vue?vue&type=script&lang=js"
export * from "./system-login.vue?vue&type=script&lang=js"

import "./system-login.vue?vue&type=style&index=0&id=d0fb20ce&lang=scss"

import exportComponent from "/Users/admin/Desktop/Project/jy-dashboard-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__